module.exports = __webpack_public_path__ + "img/eye.99add321.png";